import React from 'react'
import { useTranslation } from 'lib/i18n'
import nl2br from 'react-nl2br'

import styles from 'components/ProductPage/shared/Instructions.module.css'
import { Button } from 'components/UI/Button/Button'

export default function ExtendedInstructionsAddonBusiness({
  extendedInstructionsActive,
  extendedInstructionsProduct,
  usingSuggestion,
  textTooLong,
  toggleExtendedInstructions,
}) {
  const { t } = useTranslation()
  if (usingSuggestion) {
    return null
  }

  if (!extendedInstructionsProduct) {
    return null
  }

  const productName = extendedInstructionsProduct.product.name
  const { description } = extendedInstructionsProduct.product
  const price = extendedInstructionsProduct.price.formattedValue

  return (
    <div className={styles.instructions}>
      {textTooLong && !extendedInstructionsActive && (
        <p className={styles.instructionsExtendMessage}>
          {t(
            'ExtendedInstructionsAddon.addToWriteLonger',
            'Getting a bit long there! Add more characters.',
          )}
        </p>
      )}

      <div className={styles.extendedInstructions}>
        <div className={styles.extendedInstructionsText}>
          <p>
            <strong>{productName}</strong>
            <br />
            {nl2br(description)}
          </p>
        </div>

        <Button
          className={styles.extendedInstructionsButton}
          type={extendedInstructionsActive ? 'secondary' : 'primary'}
          onClick={toggleExtendedInstructions}
          data-cy="extendedInstructionsToggleButton"
          size="small"
        >
          {extendedInstructionsActive
            ? t('ExtendedInstructionsAddon.remove', 'Remove -{{price}}', {
                price,
              })
            : t('ExtendedInstructionsAddon.add', 'Add +{{price}}', {
                price,
              })}
        </Button>
      </div>
    </div>
  )
}
